import Footer from "components/Footer"
import Header from "components/Header"
import gsap from "gsap"
import { loader } from "library/Loader"
import { useBackButton } from "library/Loader/TransitionUtils"
import Scroll from "library/Scroll"
import { useTrackPageReady } from "library/pageReady"
import useTrackFrameTime from "library/useTrackFrameTime"
import styled, { createGlobalStyle, css } from "styled-components"
import colors, { ColorStyle } from "styles/colors"
import textStyles from "styles/text"
import { Noise } from "./Noise"
import Preloader from "./Preloader"

interface LayoutProps {
	children: React.ReactNode
}

export default function Layout({ children }: LayoutProps) {
	useTrackPageReady()
	useBackButton()
	useTrackFrameTime()

	loader.useEventListener("end", () => {
		gsap.to(".not-preloader", { opacity: 1 })
	})

	return (
		<>
			<GlobalStyle />
			<ColorStyle />
			<Header />
			<Preloader />
			<Scroll>
				<Noise />
				<Main>{children}</Main>
				<Footer />
			</Scroll>
		</>
	)
}

const Main = styled.main`
	overflow-x: clip;

	.not-preloader {
		opacity: 0;
	}
`

const globalCss = css`
	/* default text styles */
	html {
		/* if your project uses a dark color for most text, set that here */
		color: ${colors.darkBlue};
		font-family: cursive;
		${textStyles.bodyL};
		background: ${colors.lightBlue};
	}

	* {
		/* need this so that fonts match figma */
		text-rendering: geometricprecision;
		-webkit-font-smoothing: antialiased;
	}

	/** restore default focus states for elements that need them */
	*:focus-visible {
		outline: 2px solid #00f8;
	}
`

const GlobalStyle = createGlobalStyle`${globalCss}`
